<template>
    <mm-tab-title v-model="tab" :titles="titles">
        <el-button v-show="tab===1" slot="save" size="medium" type="primary" @click="submit">save</el-button>
        <div>
            <div v-show="tab===1">
                <el-form ref="form" :model="result" size="small" label-width="200px">
                    <el-form-item label="Period">
                        <el-input :value="result.period" readonly />
                    </el-form-item>
                    <el-form-item label="Channel ID">
                        <el-input v-model="result.channel_id" readonly />
                    </el-form-item>
                    <el-form-item label="Channel">
                        <el-input v-model="result.channel_name" readonly />
                    </el-form-item>
                    
                    <el-form-item label="Revenue">
                        <el-input :controls="false" v-model="result.snt_rev" readonly />
                    </el-form-item>
                    <el-form-item label="Cost">
                        <el-input :controls="false" v-model="result.snt_cost" readonly />
                    </el-form-item>
                    <el-form-item label="Fin Ded Rate">
                        <el-input :controls="false" v-model="fin_ded_rate" readonly />
                    </el-form-item>
                    <el-form-item label="Profit Margin">
                        <el-input :controls="false" v-model="profit_margin" readonly />
                    </el-form-item>
                    <!-- <el-form-item label="Dash Cost">
                        <mm-number-input v-model="result.dash_cost" />
                        <mm-upload v-model="result.dash_cost_file" dir="advSummary"></mm-upload>
                    </el-form-item> -->
                    <el-form-item label="Final Cost">
                        <mm-number-input v-model="result.confirm_cost" />
                        <el-button type="primary" plain @click="remind">Send Mail</el-button>
                    </el-form-item>
                    <el-form-item label="Paid Cost">
                        <mm-number-input v-model="result.paid_amount" />
                        <mm-upload v-model="result.paid_amount_file" dir="advSummary"></mm-upload>
                    </el-form-item>
                    <el-form-item label="Status" v-if="is_show_status">
                        <mm-summary-status v-model="result.status" />
                        <el-date-picker type="date" v-model="result.status_date"/>
                    </el-form-item>
                    <el-form-item label="Payout Type" >
                        <mm-payout-type-select v-model="result.payout_type" />
                    </el-form-item>
                    <el-form-item label="Invoice">
                        <mm-upload v-model="result.invoice_file" dir="advSummary"></mm-upload>
                    </el-form-item>
                    <el-form-item label="Remark" prop="remark">
                        <el-input v-model="result.remark" type="textarea" :rows="5" />
                        <mm-upload v-model="result.file" dir="advSummary"></mm-upload>
                    </el-form-item>
                </el-form>

            </div>
            <div v-show="tab===2">
                <div v-show="tab===2" style="height:700px;">
                    <adv-channel-summary :where="{time:result.time,channel_id:result.channel_id}" isChannelSummary />
                </div>
            </div>

        </div>
    </mm-tab-title>

</template>

<script>
import advChannelSummary from "../components/finance/advChannelSummary";

export default {
	watch: {
		$route(to, from) {
			this.loadData();
		},
		"result.confirm_cost"(data) {
			this.profit_margin = (this.result.snt_rev - this.result.ded_rev - this.result.confirm_cost === 0) ? '0.00%' : ((this.result.snt_rev - this.result.ded_rev - this.result.confirm_cost) * 100 / (this.result.snt_rev - this.result.ded_rev)).toFixed(2) + '%';
			this.fin_ded_rate = this.result.snt_cost - this.result.confirm_cost === 0 ? '0.00%' : ((this.result.snt_cost - this.result.confirm_cost) / this.result.snt_cost * 100).toFixed(2) + '%';
		}
	},
	data() {
        const user_info = this.$utils.getCookies(['is_super']);
        const is_show_status = user_info.is_super == '1'; 
		return {
			result: {},
			file_list: [],
			tab: 1,
			titles: ["Summary", "Detail"],
			profit_margin: '0%',
			fin_ded_rate : '0%',
            is_show_status,
		};
	},
	methods: {
		async submit() {
			const request_path = "/channelSummary/update";
			const result = await this.$post(request_path, this.result);
			this.loadData();
		},
		async remind() {
			const request_path = "/channelSummary/remind";
			const result = await this.$post(request_path, this.result);
			// this.loadData();
		},
		async loadData() {
			const id = this.$route.query["id"];
			this.result = await this.$post("/channelSummary/detail", {
				id: id
			});
            if (!this.result.payout_type) {
                this.result.payout_type = 'airwallex';
            }
		}
	},

	beforeMount() {
		this.loadData();
	},
	components: {
		"adv-channel-summary": advChannelSummary
	}
};
</script>